import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { paramCheck, requiredParamsCheck } from '../../utils';

export interface CloseBLEConnectionOption extends Partial<GeneralInvokeOption> {
  deviceId: string;
  invalidParamObj?: '';
}

// 关闭蓝牙低功耗设备
export function closeBLEConnection(option: CloseBLEConnectionOption) {
  if (
    !requiredParamsCheck(
      { deviceId: option.deviceId },
      option,
      APINames.Native.CLOSE_BLE_CONNECTION
    )
  ) {
    return option.invalidParamObj;
  }
  if (
    paramCheck(APINames.Native.CLOSE_BLE_CONNECTION, option, {
      deviceId: ''
    })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.CLOSE_BLE_CONNECTION,
      option
    );
  }
  return option.invalidParamObj;
}
